/**
IntroPage: show the introductory text and a couple of consent checks
*/


<template>
    <div class="intro-content">
        <img src="glacier-header.jpg" alt="A picture of a glacier">
        <h1>Welcome to GlacierMap</h1>

        <p>
            GlacierMap is a free online tool for mapping glacier change in the Cordillera Blanca mountain range of the Peruvian Andes. We designed this app with two primary
            purposes: the first, to promote education of glacier change and the knock-on impacts for downstream communities and environments; the second, to collect data on
            glacier area change in the region through “crowd sourcing” and contribute to understanding of rate of glacial retreat in response to the warming climate.
        </p>

        <p>
            To map glacier change in the Cordillera Blanca, we call on you, the general public, to help! Our citizen science glacier inventory will contribute to scientific
            data collection, while also helping to communicate the impacts of global heating and glacier retreat for downstream resources such as water, food, and energy
            production in mountain regions around the world that are reliant on glaciers as a key freshwater source.
        </p>

        <p>
            We expect the activity to take you around 15 minutes. There is a step-by-step guide showing you how to digitally map a glacier from satellite (Landsat) imagery
            with an opportunity for you to practice. You will then be able to map a glacier in the Cordillera Blanca for both 1984 and 2018 and visualise the change over
            this 34-year period. You will have an opportunity to map more glaciers after this if you want to. Finally, you will be provided with information on some of the
            impacts of glacier retreat for water, food, and energy security in Peru, so you can learn more about why glacier retreat in the Andes, and other mountain ranges,
            matters for both local people and the environment. Note that your contributions are anonymous.
        </p>

        <p>
            The glaciers you map in GlacierMap will instantly contribute to our collection of publicly-mapped glaciers in Peru. This will produce a citizen science glacier
            inventory which can be used for scientific research, so thank you for taking the time to do this!
        </p>

        <p>
            For more information on our research in Peru, please visit our project website at
            <a href="https://sigmaperu.wordpress.com/" target="_blank">https://sigmaperu.wordpress.com/</a>
        </p>

        <div class="continue" v-if="loadingState === 'error'">
            An error occurred loading the GlacierMap data - the administrator has been notified.
            <br>
            You can try again by reloading the page.
        </div>

        <div class="continue" v-if="loadingState === 'loading' && allowContinue">
            Loading data, please wait...
        </div>

        <div class="continue" v-if="loadingState === 'complete'">
            <button class="btn btn-primary btn-lg" v-on:click.prevent="checkConsent">
                Continue to GlacierMap
            </button>
        </div>
    </div>
</template>


<script>
    require("bootstrap");

    export default {
        name: "IntroPage",
        components: {},
        props: {
            loadingState: {type: String, required: true}
        },
        data: function () {
            return {
                userOver16: false,
                userHappyToParticipate: false,
                showButtonMessage: false
            }
        },
        methods: {
            checkConsent: function () {
                if (this.allowContinue) {
                    this.$emit('user-confirmed')
                }

                this.showButtonMessage = true;
            }
        },
        computed: {
            allowContinue: function () {
                return true
                // return this.userOver16 && this.userHappyToParticipate;
            }
        },
        watch: {
            userOver16: function () {
                if (this.userOver16 && this.userHappyToParticipate) {
                    this.showButtonMessage = false
                }
            },
            userHappyToParticipate: function () {
                if (this.userOver16 && this.userHappyToParticipate) {
                    this.showButtonMessage = false
                }
            }
        },
        mounted: function () {}
    }
</script>


<style lang="scss">
    .intro-content {
        img {
            max-width: 100%;
        }

        h1 {
            text-align: center;
        }

        label {
            margin: 0 5px 0 0;
        }

        .continue {
            text-align: center;
            margin-top: 16px;
        }
    }
</style>